<template>
  <div class="dashboard-wrapper" :class="{'sidebar-open': sideOpen}">
    <dashboard-sidebar></dashboard-sidebar>
    <transition name="fade">
      <sidebar-overlay v-if="sideOpen"></sidebar-overlay>
    </transition>
    <main>
      <dashboard-header></dashboard-header>
      <div class="dashboard-content">
        <div ref="progressWrapper" class="progress-wrapper">
          <div ref="progressBar" class="row" v-if="step < 4">
            <div class="col-md-4">
              <h2 class="page-title">{{ titles[`step${step}`].title }}</h2>
              <h6>{{ titles[`step${step}`].subtitle }}</h6>
            </div>
            <div class="col-md-8">
              <register-progress></register-progress>
            </div>
          </div>
        </div>
        <register-form></register-form>
      </div>
    </main>
  </div>
</template>

<script>
import smoothReflow from 'vue-smooth-reflow'
import { mapFields } from 'vuex-map-fields'
import DashboardHeader from '@/components/dashboard/DashboardHeader.vue'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar.vue'
import SidebarOverlay from '@/components/dashboard/SidebarOverlay.vue'
import RegisterForm from '@/components/dashboard/RegisterForm.vue'
import RegisterProgress from '@/components/register/RegisterProgress.vue'

export default {
  mixins: [smoothReflow],
  computed: {
    ...mapFields({
      user: 'user',
      sideOpen: 'ui.dashSideOpen',
      step: 'registration.step'
    })
  },
  components: {
    DashboardHeader,
    DashboardSidebar,
    RegisterForm,
    RegisterProgress,
    SidebarOverlay
  },
  data() {
    return {
      titles: {
        step1: {
          title: 'Company configuration setup.',
          subtitle: 'Please set your basic data for your merchant cofiguration setup.'
        },
        step2: {
          title: 'Please configure your solutions.',
          subtitle: 'Choose your merchant solutions and compare pricings.'
        },
        step3: {
          title: 'Please complete your registration.',
          subtitle: 'In order to ﬁnally setup your merchant account please enter your data.'
        }
      }
    }
  },
  mounted() {
    this.$smoothReflow({
      el: this.$refs.progressWrapper,
      transitionEvent: {
        selector: this.$refs.progressBar
      }
    })
  }
}
</script>
